import CancelDeletionAccount from './container';

export default CancelDeletionAccount;



// WEBPACK FOOTER //
// ./src/routes/CancelDeletionAccount/index.js